// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"e37cfbb4","dropzoneAnswer":"fce8cc51","dropzoneInner":"fbf2bb52","icon":"a49f8fb4","file":"c94763d1","filename":"a79e183b","removeIcon":"bf8586f0"};